import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';

import {feedbackLayoutAnatomy} from './anatomy';

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(feedbackLayoutAnatomy.keys());

const container = defineStyle(({orientation = `vertical`}) => ({
  display: `flex`,
  alignSelf: `stretch`,
  justifyContent: `center`,
  alignItems: `center`,
  flexDirection: orientation === `vertical` ? `column` : `row-reverse`,
  padding: `space-800`,
  gap: `space-400`,
}));

const body = defineStyle({
  gap: `space-050`,
});

const title = defineStyle({
  textAlign: `center`,
});

const description = defineStyle({
  textAlign: `center`,
});

const baseStyle = definePartsStyle(props => ({
  container: container(props),
  title,
  description,
  body,
}));

export const feedbackLayoutTheme = defineMultiStyleConfig({
  baseStyle,
});
